export function validCoordinates(latitude, longitude) {
  return [latitude, longitude].every(v => v !== null && v !== undefined && String(v).trim() !== "" && Number.isFinite(Number(v)))
    && Math.abs(Number(latitude)) <= 90 && Math.abs(Number(longitude)) <= 180
    && !(Number(latitude) === 0 && Number(longitude) === 0);
}

export function locationIssue(value = {}) {
  if (!String(value.name || "").trim()) return "name";
  if (!value.roles?.length) return "roles";
  if (!String(value.streetName ?? value.address?.streetName ?? "").trim()) return "address";
  if (!validCoordinates(value.latitude, value.longitude)) return "coordinates";
  return null;
}

export function parseCoordinatePair(query) {
  const match = String(query).trim().match(/^\(?\s*([+-]?\d+(?:\.\d+)?)\s*[,;]\s*([+-]?\d+(?:\.\d+)?)\s*\)?$/);
  if (!match) return null;
  return validCoordinates(match[1], match[2]) ? { lat: Number(match[1]), lng: Number(match[2]) } : { invalid: true };
}
